const defaulrModalOptions = {
  size: 'sm',
  centered: true,
  buttonSize: '-small',
  okVariant: '-secondary',
  cancelVariant: '-ternary'
};

export default {
  methods: {
    msgBoxOk(message, options) {
      const opts = Object.assign({okTitle: this.$t('buttons.ok')}, defaulrModalOptions, options);
      return this.$bvModal.msgBoxOk(message, opts);
    },
    msgBoxConfirm(message, options) {
      const opts = Object.assign({okTitle: this.$t('buttons.ok'), cancelTitle: this.$t('buttons.cancel')}, defaulrModalOptions, options);
      return this.$bvModal.msgBoxConfirm(message, opts);
    },

    toastHtml(content, options) {
      const vNodesMsg = this.$createElement('div', {domProps:{innerHTML: content}});
      this.$root.$bvToast.toast([vNodesMsg], Object.assign({
        title: null,
        solid: true,
        autoHideDelay: 5000,
        appendToast: true,
        toaster: 'b-toaster-bottom-left'
      }, options));
    },

    toast(message, options) {
      this.$root.$bvToast.toast(message, Object.assign({
        title: null,
        solid: true,
        autoHideDelay: 5000,
        appendToast: true,
        toaster: 'b-toaster-bottom-left'
      }, options));
    }
  }
}
